const LINE_STATES = {
  OFF: 0,
  FLASH: 1,
  HOLD: 2,
  ON: 3,
  ON_AWAY: 4,
  DIALTONE: 5,
  ERROR: 6
};

const BLF_STATUS = {
  FREE: 0,
  ONLINE: 1,
  DND_ON: 9,
  OFFERING: 10,
  CALL_FORWARD_ON: 12,
  DND_OFF: 13,
  CALL_FORWARD_OFF: 14,
  HOLD: 15
};

const TELEPHONY = {
  MITEL: "mitel"
};

const ACTION_TYPE = {
  MAKE_CALL: 1,
  HOLD: 2,
  UNHOLD: 3,
  RELEASE: 4,
  ANSWER: 5,
  DIRECT_TRANSFER: 6,
  ASSISTED_TRANSFER: 7,
  REDIAL: 8,
  CALL_PARK: 9,
  CALL_FORWARD: 10,
  CALL_FORWARD_REMOVE: 11,
  DND: 12,
  DND_REMOVE: 13,
  SWITCH_TRANSFER: 14,
  CONFERENCE_TRANSFER: 15,
  RESUME_TRANSFER: 16,
  COMPLETE_TRANSFER: 17,
  VOICEMAIL_TRANSFER: 18,
  SILENT_MONITORING: 19,
  LINK: 20,
  MAKE_CALL_AND_NOTIF: 21,
  CALL_VOICEMAIL: 22,
  CONFERENCE: 23,
  CALLBACK: 24,
  RINGBACK: 25
};

const LINE_COLORS = {
  [LINE_STATES.OFF]: "#757575",
  [LINE_STATES.FLASH]: "#FFFF00",
  [LINE_STATES.HOLD]: "#E64A00",
  [LINE_STATES.ON]: "#00FF00",
  [LINE_STATES.ON_AWAY]: "#FF0000",
  [LINE_STATES.DIALTONE]: "#00FF00"
};

const ASSISTED_TRANSFER_BUTTON_TYPE = {
  SWITCH_TRANSFER_1: { id: 1, text: "Caller" },
  SWITCH_TRANSFER_2: { id: 2, text: "Callee" },
  CONFERENCE_TRANSFER: { id: 3, text: "Link" },
  RESUME_TRANSFER: { id: 4, text: "Resume" },
  COMPLETE_TRANSFER: { id: 5, text: "Complete" }
};

const ASSISTED_TRANSFER_BUTTON_ARRAY = [
  ASSISTED_TRANSFER_BUTTON_TYPE.SWITCH_TRANSFER_1,
  ASSISTED_TRANSFER_BUTTON_TYPE.SWITCH_TRANSFER_2,
  ASSISTED_TRANSFER_BUTTON_TYPE.CONFERENCE_TRANSFER,
  ASSISTED_TRANSFER_BUTTON_TYPE.RESUME_TRANSFER,
  ASSISTED_TRANSFER_BUTTON_TYPE.COMPLETE_TRANSFER
];

const TRANSFER_TYPE = {
  DIRECT: 0,
  ASSISTED: 1,
  CONFERENCE: 2
};

const CALL_MANAGER_TYPES = {
  NO_ACTION: 0,
  CHANGE_DISPLAY_COLOR: 10,
  PLAY_WAV_FILE: 20,
  CHANGE_TITLE_BAR_TEXT: 30,
  CHANGE_DISPLAY_GROUP: 40,
  CHANGE_CAPTION_LINE_BUTTON: 50,
  ANSWER_CALL: 55,
  HANGUP_CALL: 60,
  TRANSFER_CALL: 70,
  PRIORITY_CALL: 80,
  FIELD_FILTER: 90
};

const CALL_MANAGER_TRIGGERS = {
  ALWAYS: 0,
  OFFERING: 1,
  ONLINE: 2
};

const NOTIFICATION_TYPES = {
  INFO: { id: 0, name: "info" },
  WARNING: { id: 1, name: "warning" },
  ERROR: { id: 2, name: "error" },
  SUCCESS: { id: 3, name: "success" }
};

const LICENSE_TYPES = { LAYOUT: { id: 0, name: "layout" }, DRAWER: { id: 0, name: "drawer" } };

const PASSWORD_COMPLEXITY = { NOTHING: 0, NONE: 1, BASIC: 2, ADVANCED: 3 };

const PINNED_APP_TYPES = {
  APP_LAYOUT: 0,
  GLOBAL_LAYOUT: 1,
  PERSONAL_LAYOUT: 2
};

const KLOUD_CONFIGURATION_CONTEXTS = {
  KOMAND: "KomandGeneral",
  MAIL: "Mail"
};
const LANGUAGES = {
  ENGLISH: { id: "en", name: "English" },
  FRENCH: { id: "fr", name: "French" }
};

const LINES_TYPES = {
  EMPTY: 0,
  AUTO_LINE: 1,
  AUTO_DIAL: 2,
  TRANSFER: 3,
  INTERCOM: 4,
  CALL_PARK: 5,
  PAGE_ALL: 6,
  PAGE_SPKR: 7,
  PAGE_ZONE: 8,
  CONFERENCE: 9,
  CONFERENCE6: 10,
  TRANS_CONF: 11,
  PRESS_KEY: 12,
  LED: 13,
  AUTO_LINE_PRESS_KEY: 14,
  RADIO: 15,
  NOT_READY: 16
};

const MEDIA_STATE_TEXT = {
  0: "None",
  1: "Active",
  2: "LocalHold",
  3: "RemoteHold",
  4: "None"
};

module.exports = {
  LINE_STATES,
  TELEPHONY,
  ACTION_TYPE,
  LINE_COLORS,
  ASSISTED_TRANSFER_BUTTON_TYPE,
  ASSISTED_TRANSFER_BUTTON_ARRAY,
  BLF_STATUS,
  TRANSFER_TYPE,
  CALL_MANAGER_TYPES,
  CALL_MANAGER_TRIGGERS,
  NOTIFICATION_TYPES,
  LICENSE_TYPES,
  PASSWORD_COMPLEXITY,
  PINNED_APP_TYPES,
  KLOUD_CONFIGURATION_CONTEXTS,
  LANGUAGES,
  LINES_TYPES,
  MEDIA_STATE_TEXT
};
